import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { StockgroupOverview } from "@/components/StockgroupOverview";
import { Button } from "@/components/ui/button";
import { AppSettingsButton } from "@/components/AppSettings";
import { Boxes, LogOut, ArrowLeft } from "lucide-react";

export default function Stockgroup() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const admin = user?.role === "admin";

  return (
    <div className="min-h-screen bg-[#f8fafc] text-slate-800">
      <header className="border-b border-[#e2e8f0] px-4 lg:px-8 py-3 sm:py-0 sm:h-16 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-emerald-600 flex items-center justify-center">
            <Boxes className="w-4 h-4 text-white" strokeWidth={2} />
          </div>
          <div className="leading-tight">
            <p className="font-heading font-bold tracking-tight text-sm">Stockgroup</p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Aftræksoversigt</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
          {admin && (
            <Button variant="outline" onClick={() => navigate("/")}
              className="h-9 rounded-lg bg-[#ffffff] border-[#e2e8f0] text-slate-700 hover:bg-[#eef2f6] hover:text-slate-900 gap-2" data-testid="stockgroup-back-btn">
              <ArrowLeft className="w-4 h-4" /> Dashboard
            </Button>
          )}
          <AppSettingsButton />
          <Button variant="ghost" size="sm" onClick={logout} className="h-9 rounded-lg text-slate-500 hover:text-slate-900 hover:bg-[#eef2f6]" data-testid="stockgroup-logout-btn">
            <LogOut className="w-4 h-4 mr-1.5" /> Log ud
          </Button>
        </div>
      </header>
      <main className="p-4 lg:p-6">
        <StockgroupOverview />
      </main>
    </div>
  );
}
